import React, { useState, useEffect } from "react";
import Navbar2 from "../components/navbar/Navbar2";
import AOS from "aos";
import "aos/dist/aos.css";
import { socket, api } from "../api";
import TelebirrDepositModal from "./TelebirrDepositModal";
import { toast } from "react-toastify";
import axios from "axios";
import { parseJWT } from "../utils/jwtUtils";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "../components/navbar/Footer";

// console.log("user info : ", token);
export default function WalletPage() {
  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 500,
      easing: "ease-in-sine",
      delay: 100,
    });
    AOS.refresh();
  }, []);
  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);

  const [activeTab, setActiveTab] = useState("deposit");
  const [balance, setBalance] = useState(0);
  const [totalIncome, setTotalIncome] = useState(0);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (userInfo?.phone) {
      //   console.log("Requesting balance for phone:", userInfo.phone);
      socket.emit("getBalance", { phone: userInfo.phone });

      socket.on("balanceResponse", (data) => {
        //  console.log("Received balance response from server:", data);
        if (data.success) {
          setBalance(data.balance);
        }
      });
    }

    return () => {
      socket.off("balanceResponse");
    };
  }, [userInfo?.phone]);

  useEffect(() => {
    const fetchReferrals = async () => {
      try {
        if (!userInfo?.referralCode) {
          setMessage("00.0");
          setLoading(false);
          return;
        }

        // ✅ Fetch referrals using shared API instance
        const { data } = await api.get(`/referrals/${userInfo.referralCode}`);
        // console.log("referral info : ", data);
        if (data.success) {
          setTotalIncome(data.totalIncome || 0);
          setMessage("");
        } else {
          setMessage(data.message || "Unable to load referral data.");
        }
      } catch (err) {
        //  console.error("⚠️ Failed to fetch referral history:", err);
        setMessage("0.00");
      } finally {
        setLoading(false);
      }
    };

    fetchReferrals();
  }, []);
  const { t: translate } = useTranslation(["WalletPage"]);
  return (
    <>
      {/* Navbar */}
      <div className="fixed left-0 right-0 top-0 z-50">
        <Navbar2 />
      </div>
      <div className="min-h-screen bg-[#0a0f2c] text-white pt-24 md:pt-20">
        {/* Top Tabs (Like Image) */}
        <div className="flex justify-around text-sm font-semibold border-b border-gray-700">
          {[
            { key: "deposit", label: translate("Deposit") },
            { key: "withdraw", label: translate("Withdraw") },
            { key: "history", label: translate("History") },
          ].map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`relative py-4 px-2 transition ${
                activeTab === tab.key ? "text-green-400" : "text-gray-400"
              }`}
            >
              {tab.label}

              {/* Yellow Underline */}
              {activeTab === tab.key && (
                <span className="absolute left-0 bottom-0 w-full h-[3px] bg-green-400 rounded-full" />
              )}
            </button>
          ))}
        </div>

        {/* Balance Section (No Card Box, Just Clean Spacing) */}
        <div className="px-4 py-6 space-y-4">
          <div className="flex justify-between items-center px-6">
            <div>
              <p className="text-gray-400 text-sm">
                {translate("Main_Balance")}
              </p>
              <p className="text-2xl font-bold text-green-400">
                {balance} {translate("ETB")}
              </p>
            </div>

            <div className="text-right">
              <p className="text-gray-400 text-sm">
                {translate("Bonus_Balance")}
              </p>

              {loading ? (
                <p className="text-gray-400">Loading...</p>
              ) : message ? (
                <p className="text-red-400">{message}</p>
              ) : (
                <p className="text-xl font-bold text-green-400">
                  {totalIncome.toFixed(1)} {translate("ETB")}
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Dynamic Section (NO background box) */}
        <div className="px-4 pb-12">
          {activeTab === "deposit" && <DepositSection />}
          {activeTab === "withdraw" && <WithdrawSection />}
          {activeTab === "history" && <HistorySection />}
        </div>
      </div>
    </>
  );
}

function DepositSection() {
  const [showTelebirrModal, setShowTelebirrModal] = useState(false);
  const [amount, setAmount] = useState("");

  const handleChapaPayment = async (title) => {
    // ✅ Get fresh userInfo from localStorage
    const token = localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo"))
      : null;
    const userInfo = parseJWT(token?.token);

    if (!userInfo?.id || !userInfo?.phone) {
      toast.error("User info not available yet. Please try again.");
      return;
    }
    // console.log("amount :", amount);
    // 1️⃣ Check empty or whitespace
    // ✅ Check if amount is empty
    if (
      amount === "" || // empty
      amount === null || // safety
      amount === undefined || // safety
      isNaN(amount) || // not a number
      Number(amount) <= 0 // zero or negative
    ) {
      toast.error("እባክዎ የተቀማጭ ገንዘብ መጠን ያስገቡ!");

      return;
    }
    const depositAmount = Number(amount);

    if (isNaN(depositAmount)) {
      toast.error("እባክዎ የተቀማጭ ገንዘብ መጠን ያስገቡ!");
      return;
    }

    if (depositAmount < 25) {
      toast.error("ውድ ደንበኛችን ዝቅተኛ ገቢ 25 ብር ነው!");
      return;
    }

    try {
      const orderData = {
        amount: depositAmount,
        userId: userInfo?.id,
        phone_number: userInfo?.phone,
        title,
      };
      //console.log("payment detail : ", orderData);
      toast.info("ክፍያን በማስኬድ ላይ...");

      const res = await axios.post(
        "https://backend.enatgames.com/payment-api/chapaOrder",
        orderData,
      );
      //  console.log("response : ", res);

      if (res.data.success === true && res.data.checkout_url) {
        window.location.replace(res.data.checkout_url);
      } else {
        toast.error("ክፍያውን መፈጸም አልተቻለም! እባክዎ እንደገና ይሞክሩ።");
        // console.error("Unexpected backend response:", res.data);
      }
    } catch (err) {
      // console.error("Payment Error:", err);
      toast.error(err.response?.data?.message || "Error creating payment.");
    }
  };

  const { t: translate } = useTranslation(["WalletPage"]);

  return (
    <div className="max-w-md mx-auto">
      <h3 className="text-xl font-semibold mb-6 font-serif">
        {translate("Deposit")}
      </h3>

      {/* Amount Input */}
      <div className="mb-6">
        <label className="block mb-2 text-sm text-gray-300">
          Amount (ETB) *(Minimum 25 ብር)
        </label>

        <input
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder="Enter Amount"
          className="
          w-full px-4 py-4
          rounded-xl
          bg-[#1b1f3a]
          text-white
          border border-gray-700
          focus:outline-none
          focus:ring-2
          focus:ring-green-400
          placeholder-gray-400
          text-lg
        "
        />
      </div>

      {/* Deposit Button */}
      <button
        onClick={() => handleChapaPayment("Chapa")}
        className="
        w-full py-4
        rounded-xl
        bg-[#0c994f]
        text-black
        font-semibold
        text-lg
        hover:opacity-90
        transition
      "
      >
        {translate("Deposit")}
      </button>

      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
    </div>
  );
}

function DepositCard({ title, fee, onTransfer }) {
  const { t: translate } = useTranslation(["WalletPage"]);
  return (
    <div className="bg-primary p-4 rounded-lg flex-1 flex flex-col justify-between items-center hover:bg-[#032c3aff] transition font-serif">
      <p className="text-lg font-semibold">{title}</p>
      <p className="text-sm text-green-400">{fee}</p>
      <button
        type="button"
        onClick={onTransfer}
        className="
    mt-3 px-4 py-2 text-black bg-[#c99510] rounded-lg
    ring-2 ring-[#c99510] ring-offset-2 ring-offset-green-100
    animate-pulse
    hover:bg-[#E0AF53]
  "
      >
        {translate("Transfer")}
      </button>
      <Footer />
    </div>
  );
}

function WithdrawSection() {
  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);
  const [amount, setAmount] = useState("");
  const [bank, setBank] = useState("");
  const [accountNumber, setAccountNumber] = useState(userInfo?.phone);
  const [accountName, setAccountName] = useState("");
  const [otp, setOtp] = useState("");

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(0);

  // -------------------------------
  // LISTEN FOR OTP RESPONSE
  // -------------------------------
  useEffect(() => {
    socket.on("withdrawOTPResponse", (data) => {
      if (data.success) {
        setMessage(`OTP sent! (Code: ${data.otp})`);
        setOtp(data.otp); // auto fill OTP like Signup
        setTimer(30);
      } else {
        setMessage(data.message || "ኦቲፒን መላክ አልተሳካም።");
      }
    });

    socket.on("withdrawResponse", (data) => {
      setLoading(false);

      if (data.success) {
        setMessage("የወጭ ጥያቄ በተሳካ ሁኔታ ተልኳል!");
      } else {
        setMessage(data.message || "ወጭ አልተሳካም።");
      }
    });

    return () => {
      socket.off("withdrawOTPResponse");
      socket.off("withdrawResponse");
    };
  }, []);

  // Countdown timer
  useEffect(() => {
    if (timer <= 0) return;
    const countdown = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(countdown);
  }, [timer]);

  // -------------------------------
  // SEND OTP
  // -------------------------------
  const sendOtp = () => {
    if (!accountNumber) {
      setMessage("እባክዎ መጀመሪያ ስልክ ቁጥር ያስገቡ።");
      return;
    }

    setMessage("Sending OTP...");

    socket.emit("sendWithdrawOTP", { phone: userInfo?.phone });
  };

  // -------------------------------
  // SUBMIT WITHDRAW REQUEST
  // -------------------------------
  const sendWithdraw = (e) => {
    e.preventDefault();

    // Required fields
    if (!amount || !bank || !accountNumber || !accountName || !otp) {
      setMessage("ሁሉንም መረጃ ያስገቡ!");
      return;
    }

    // Minimum withdraw
    if (parseInt(amount) < 100) {
      setMessage("ዝቅተኛ የወጭ መጠን 100 ብር ነው።");
      return;
    }

    setLoading(true);
    const payload = {
      amount,
      bank,
      accountNumber,
      accountName,
      otp,
      userId: userInfo?.id,
    };

    socket.emit("withdraw-request", payload);
  };
  const { t: translate } = useTranslation(["WalletPage"]);
  return (
    <div className="max-w-md mx-auto">
      <h3 className="text-xl font-semibold mb-6 font-serif">
        {translate("Withdraw")}
      </h3>

      <form className="space-y-5" onSubmit={sendWithdraw}>
        {/* Payment Method */}
        <div>
          <label className="block mb-2 text-sm text-gray-300">
            Payment Method *
          </label>

          <select
            value={bank}
            onChange={(e) => setBank(e.target.value)}
            className="
            w-full px-4 py-4
            rounded-xl
            bg-[#617a6d]
            text-white
            border border-green-500
            focus:outline-none
            focus:ring-2
            focus:ring-green-400
          "
          >
            <option value="">Select Payment Method</option>
            <option value="Telebirr">ቴሌብር</option>
            <option value="Safari">ሳፋሪ</option>
            <option value="CBE">ሲቢኢ ብር</option>
          </select>
        </div>

        {/* Account Number */}
        <div>
          <label className="block mb-2 text-sm text-gray-300">
            Account Number *
          </label>

          <input
            type="text"
            value={accountNumber}
            readOnly
            className="
            w-full px-4 py-4
            rounded-xl
            bg-[#1b1f3a]
            text-white
            border border-gray-700
            focus:outline-none
          "
          />
        </div>

        {/* Amount */}
        <div>
          <label className="block mb-2 text-sm text-gray-300">
            Amount (ETB)
          </label>

          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter Amount"
            className="
            w-full px-4 py-4
            rounded-xl
            bg-[#1b1f3a]
            text-white
            border border-gray-700
            focus:outline-none
            focus:ring-2
            focus:ring-green-400
            text-lg
          "
          />
        </div>

        {/* Account Holder */}
        <div>
          <label className="block mb-2 text-sm text-gray-300">
            Account Holder *
          </label>

          <input
            type="text"
            value={accountName}
            onChange={(e) => setAccountName(e.target.value)}
            placeholder="Full Name"
            className="
            w-full px-4 py-4
            rounded-xl
            bg-[#1b1f3a]
            text-white
            border border-gray-700
            focus:outline-none
            focus:ring-2
            focus:ring-green-400
          "
          />
        </div>

        {/* OTP */}
        <div className="flex gap-3">
          <input
            type="text"
            placeholder="OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            className="
            flex-1 px-4 py-4
            rounded-xl
            bg-[#1b1f3a]
            text-white
            border border-gray-700
            focus:outline-none
            focus:ring-2
            focus:ring-green-400
          "
          />

          <button
            type="button"
            onClick={sendOtp}
            disabled={timer > 0}
            className="
            px-4
            rounded-xl
            bg-green-600
            text-white
            text-sm
            hover:bg-green-700
            disabled:bg-gray-600
          "
          >
            {timer > 0 ? `${timer}s` : "Send OTP"}
          </button>
        </div>

        {/* Withdraw Button */}
        <button
          type="submit"
          disabled={loading}
          className="
          w-full py-4
          rounded-xl
          bg-[#0c994f]
          text-black
          font-semibold
          text-lg
          hover:opacity-90
          transition
          disabled:bg-gray-600
        "
        >
          {loading ? "Processing..." : "Withdraw"}
        </button>
      </form>

      {message && <p className="text-green-300 text-sm mt-4">{message}</p>}
    </div>
  );
}

function HistorySection() {
  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);
  const [history, setHistory] = useState([]);
  const phone = userInfo?.phone; // Logged-in user's phone number

  const fetchHistory = async () => {
    try {
      const res = await api.get(`/withdrawals/by-phone/${phone}`);
      //  console.log("Withdrawals response:", res.data);

      if (Array.isArray(res.data.withdrawals)) {
        setHistory(res.data.withdrawals);
      } else {
        setHistory([]);
      }
    } catch (error) {
      console.error(
        "❌ Error fetching withdrawal history:",
        error.response?.data || error,
      );
      setHistory([]);
    }
  };

  useEffect(() => {
    if (phone) fetchHistory();
  }, [phone]);
  const { t: translate } = useTranslation(["WalletPage"]);
  return (
    <div className="max-w-md mx-auto">
      <h3 className="text-xl font-semibold mb-6">
        {translate("Transaction_History")}
      </h3>

      {history.length === 0 ? (
        <div className="text-center text-gray-400 py-8">
          {translate("No_transactions")}
        </div>
      ) : (
        <div className="space-y-4">
          {history.map((item) => (
            <div
              key={item.id}
              className="
              bg-[#1b1f3a]
              p-4
              rounded-xl
              border border-gray-700
              flex justify-between items-center
            "
            >
              <div>
                <p className="font-semibold text-white">Withdraw</p>
                <p className="text-sm text-gray-400">
                  {item.createdAt?.split("T")[0] || "-"}
                </p>
              </div>

              <div className="text-right">
                <p className="text-lg font-bold text-green-400">
                  {item.amount} ETB
                </p>

                <p
                  className={`text-sm ${
                    item.status === "success"
                      ? "text-green-400"
                      : item.status === "pending"
                        ? "text-green-400"
                        : "text-red-400"
                  }`}
                >
                  {item.status}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}


